var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLandingStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 743,
    height: 843,
    viewBox: "0 0 743 843",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m642.171 98.812 44.451-32.907c1.758-1.3 4.348-.929 5.741 1.006 1.342 1.893.945 4.488-.826 5.814l-.005.004-44.44 32.898-7.418 5.491 9.045 1.554 37.677 6.473.007.002.008.001c1.185.198 2.077 1.426 1.894 2.704-.161 1.123-1.256 2.012-2.524 1.804l-.007-.001-37.661-6.471-9.199-1.58 5.514 7.746 32.837 46.131v.001h.001c1.345 1.893.95 4.491-.823 5.819-1.759 1.295-4.344.92-5.735-1.014l-.004-.004-32.828-46.12-5.468-7.682-1.375 9.383-5.64 38.471-.002.012c-.161 1.125-1.26 2.016-2.531 1.804-1.183-.198-2.075-1.422-1.895-2.698l.001-.006 5.685-38.513 1.365-9.245-7.372 5.457-44.451 32.907-.001.001c-1.759 1.3-4.348.927-5.741-1.007-1.341-1.893-.944-4.488.827-5.814l.005-.004 44.44-32.898 7.417-5.491-9.044-1.554-37.677-6.473-.008-.002-.008-.001c-1.185-.198-2.077-1.426-1.894-2.704.161-1.123 1.257-2.013 2.526-1.804l.006.001 37.661 6.471 9.198 1.58-5.514-7.746-32.837-46.132-.004-.006-.004-.006c-1.386-1.931-.948-4.468.775-5.743 1.759-1.301 4.35-.929 5.743 1.007l.003.006 32.829 46.12 5.46 7.67 1.383-9.368 5.687-38.529.001-.008.002-.008c.161-1.125 1.26-2.016 2.531-1.803l.595-3.867-.595 3.866c1.183.198 2.074 1.422 1.895 2.698l-.001.006-5.685 38.513-1.365 9.245z",
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeWidth: 7.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M532.447 182.683C318.011 343.534 165.037 549.774 73.265 801.477",
    stroke: "url(#c)",
    strokeWidth: 10.956,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 714.492,
    y1: 169.646,
    x2: 550.676,
    y2: 238.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F5E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FAD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 714.492,
    y1: 169.646,
    x2: 550.676,
    y2: 238.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F5E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FAD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 357.462,
    y1: 469.997,
    x2: 191.671,
    y2: 380.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F5E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FAD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLandingStar);
export default __webpack_public_path__ + "static/media/bg-landing-star.b53f69e85d0daa6ee085ddbdea091cb1.svg";
export { ForwardRef as ReactComponent };